import { render, staticRenderFns } from "./ThesisEdit.vue?vue&type=template&id=9c08c08a&scoped=true"
import script from "./ThesisEdit.vue?vue&type=script&lang=js"
export * from "./ThesisEdit.vue?vue&type=script&lang=js"
import style0 from "./ThesisEdit.vue?vue&type=style&index=0&id=9c08c08a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c08c08a",
  null
  
)

export default component.exports